(function () {
  // Approximate centroid (longitude, latitude) and region tab per delivery country: E Europe, M Middle East, A Asia Pacific, C Americas.
  // Small islands and micro-states are nudged apart so no two dots touch.
  var GEO = 'AX 19.9 60.2 E;AD 1.5 42.5 E;AI -63.4 19.4 C;AG -60.9 16.8 C;AW -70.7 12.9 C;AU 134 -25 A;AT 14.4 47.9 E;BS -77.4 24.5 C;BH 50.5 26.2 M;BB -59.4 13.1 C;BE 4.1 50.6 E;BM -64.7 32.3 C;BN 114.7 4.5 A;BG 25.4 42.7 E;BQ -67.3 12.3 C;KY -81.2 19.3 C;CN 104 35 A;HR 16.6 44.5 E;CW -69.2 11.7 C;CY 33.2 35.1 E;CZ 15.4 49.8 E;DK 9.5 56.1 E;EE 25.6 58.8 E;FI 26 64 E;FR 2.4 46.6 E;DE 10.4 51.1 E;GI -5.3 36.1 E;GR 22 39.3 E;GG -3.4 49.9 E;HK 116.2 22.8 A;HU 19.4 47 E;IS -19 64.9 E;IN 79 22 A;ID 115 -2 A;IE -8 53.3 E;IM -4.6 54.2 E;IL 34.9 31.4 M;IT 13.1 42.9 E;JP 138.3 36.5 A;JE -1.3 48.8 E;KW 47.6 29.3 M;LV 24.6 56.9 E;LI 10.1 47.3 E;LT 23.8 55 E;LU 6.4 49.7 E;MO 111.3 21.6 A;MY 101.4 4.3 A;MT 14.4 35.9 E;MC 7.4 43.7 E;NL 5.4 52.3 E;NZ 172.5 -41.5 A;NO 9 61 E;OM 57 21 M;PH 122 12 A;PL 19.4 52.1 E;PT -8.2 39.6 E;QA 51.3 25.2 M;RO 25 45.9 E;SM 12.2 44.7 E;SA 45 24 M;SG 104.2 0.9 A;SX -65.2 17.9 C;SK 19.7 48.9 E;SI 14.7 45.9 E;KR 127.8 36.5 A;ES -3.7 40.2 E;BL -61.1 18.6 C;KN -62.9 16.1 C;LC -61.2 14 C;MF -63 17.8 C;SE 15.5 62 E;CH 7.6 46.7 E;TW 121.3 23.7 A;TH 101 15 A;TC -71.8 21.8 C;AE 54 24 M;GB -2 54 E;US -98.6 39.8 C;VA 12.1 41 E;VN 106.3 16.5 A';
  var LL = {};
  var REGION = {};
  GEO.split(';').forEach(function (row) { var p = row.split(' '); LL[p[0]] = [+p[1], +p[2]]; REGION[p[0]] = p[3]; });
  var ALIASES = { GB: 'uk united kingdom great britain britain england scotland wales northern ireland', US: 'usa america united states of america', AE: 'uae emirates dubai abu dhabi', NL: 'holland nederland', CZ: 'czech republic cesko', KR: 'korea', DE: 'deutschland', AT: 'osterreich', CH: 'swiss schweiz suisse svizzera', ES: 'espana', IT: 'italia', PL: 'polska', SK: 'slovensko', HU: 'magyarorszag', BE: 'belgie belgique', GR: 'hellas ellada', SE: 'sverige', NO: 'norge', DK: 'danmark', FI: 'suomi', HR: 'hrvatska', SI: 'slovenija', EE: 'eesti', LV: 'latvija', LT: 'lietuva', VA: 'holy see', HK: 'hongkong', MO: 'macau', TC: 'turks and caicos' };
  // Where each welcome word sits: its language's home country; Arabic over the Gulf waters between Bahrain, Qatar and the Emirates.
  var HOME = { en: 'GB', de: 'DE', fr: 'FR', it: 'IT', es: 'ES', pl: 'PL', nl: 'NL', da: 'DK', fi: 'FI', cs: 'CZ', sv: 'SE', sk: 'SK', 'pt-PT': 'PT', et: 'EE', no: 'NO', hu: 'HU', ro: 'RO', el: 'GR', he: 'IL', ar: 'AE' };
  var GULF = [52, 27.2];
  // Danish and Norwegian both say "Velkommen": the map names the language beside the word, so the two spots never read as one.
  var TWIN = { da: 'Dansk', no: 'Norsk' };
  // How many map words show beside the visitor's own languages; every other spot in view is a dot that shows its word on hover.
  var NEAR = 6;
  var MOVE = 'cubic-bezier(0.65, 0, 0.35, 1)';
  var ARRIVE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#222222" stroke-width="2" aria-hidden="true" focusable="false"><path d="m5 12 5 5 9-10"/></svg>';
  // Decorative 2-degree world land mask (equirectangular). Row 0 = latitude 90..88, column 0 = longitude -180..-178; '1' = land.
  // The all-sea rows south of the last land row are left out.
  var LAND_ROWS = [
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000011111111000000000000111111111100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000111111111111111111111111111111111111110000000000000000011000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000001111111111111111111111111111111111111000000000000000111111100000000000000000000000000000000000111100000000000000000000000000000000000000',
    '000000000000000000000000000000001111111100000111111000011111111111111111111111111000000000000000011100000000000000000000111100000000000000001111000000000000000000000000000000000000',
    '000000000000000000000000000000001111111100001111110000000000011111111111111111110000000000000000000000000000000000000111110000000000011111111111110000000000000111110000000000000000',
    '000000000000000000000000000011111111110011110111111100000000001111111111111111100000000000000000000000000000000000001110000001100011111111111111111111111100000001000000000000000000',
    '000000000001110000000000000011111111111001010111111111100000001111111111111111100000000000000000000000111000000000001000000011111111111111111111111111111111111111111111100000000000',
    '111110001111111111111111111111111111111000111001100111111000000011111111111110000000000000000000001111111111100000000011111111111111111111111111111111111111111111111111111111111111',
    '111110001111111111111111111111111111111111111111100001111110000011111111100000011100000000000000011111111111111011111111111111111111111111111111111111111111111111111111111111111111',
    '001100111111111111111111111111111111111111111101100011111100000011111110000000111110000000000001111110111110011111111111111111111111111111111111111111111111111111111111111111111111',
    '000000001111111111111111111111111111111111111001100001111100000001111100000000011000000000000111111001111111111111111111111111111111111111111111111111111111111111111111111111111110',
    '000000011111111111111111111111111111111111100000000111100000000000111000000000000000000000001111111001111111111111111111111111111111111111111111111111111111111111111111111111110000',
    '000000000111110000000111111111111111111111100000000111100110000000000000000000000000000000000111111000111111111111111111111111111111111111111111111111111111111111111110011100000000',
    '000000000011100000000001111111111111111111111000000111111110000000000000000000000000000110000010110001111111111111111111111111111111111111111111111111111111111100000000111000000000',
    '000000000100000000000000011111111111111111111111100111111111100000000000000000000000011111000011100011111111111111111111111111111111111111111111111111111111111000000000111000000000',
    '000000000000000000000000001111111111111111111111101111111111110000000000000000000000011011101111111111111111111111111111111111111111111111111111111111111111111111000000110000000000',
    '000000000000000000000000001111111111111111111111111111111111110000000000000000000000010111111111111111111111111111111111111111111111111111111111111111111111111111000000000000000000',
    '000000000000000000000000000111111111111111111111111111111100111000000000000000000000000011111111111111111111111111111111111111111111111111111111111111111111111101000000000000000000',
    '000000000000000000000000000011111111111111111111111111111100011100000000000000000000000001111111111111111111111111111111111111111111111111111111111111111111111101000000000000000000',
    '000000000000000000000000000011111111111111111111111111111110000000000000000000000000000001111111111111111010011111001111111111111111111111111111111111111111111011000000000000000000',
    '000000000000000000000000000011111111111111111111111111100000000000000000000000000000001111110011101111110000001111001111111111111111111111111111111111111111100011100000000000000000',
    '000000000000000000000000000011111111111111111111111111000000000000000000000000000000011111100010011011111111111111101111111111111111111111111111111111111110000010000000000000000000',
    '000000000000000000000000000011111111111111111111111110000000000000000000000000000000011111000010000011011111111111100111111111111111111111111111111110001100000110000000000000000000',
    '000000000000000000000000000001111111111111111111111100000000000000000000000000000000001110011110110001001111111111111111111111111111111111111111111111100110001110000000000000000000',
    '000000000000000000000000000001111111111111111111111100000000000000000000000000000000000111111110000000100010111111111111111111111111111111111111111111000100111100000000000000000000',
    '000000000000000000000000000000011111111111111111110000000000000000000000000000000000001111111111100000000001111111111111111111111111111111111111111111100001100000000000000000000000',
    '000000000000000000000000000000001111111111111111110000000000000000000000000000000000011111111111111011111111111111111111111111111111111111111111111111100001000000000000000000000000',
    '000000000000000000000000000000001111111111100000110000000000000000000000000000000000011111111111111111111111111111011111111111111111111111111111111111100000000000000000000000000000',
    '000000000000000000000000000000000101111111000000010000000000000000000000000000000001111111111111111111111110111111101111111111111111111111111111111111000000000000000000000000000000',
    '000000000000000000000000000000000010111111000000000000000000000000000000000000000011111111111111111111111111011111110100111111111111111111111111111111100000000000000000000000000000',
    '000000000000000000000000000000000000011110000000111000000000000000000000000000000011111111111111111111111111011111111111000011111111111111111111111100100000000000000000000000000000',
    '000000000000000000000000000000000000011110000100111110000000000000000000000000000011111111111111111111111111101111111111000000111111110011111111000000000000000000000000000000000000',
    '000000000000100000000000000000000000001111001100000101111000000000000000000000000011111111111111111111111111101111111110000000111111100001111110110000100000000000000000000000000000',
    '000000000000000000000000000000000000000011111100000000000000000000000000000000000011111111111111111111111111110111111000000000011111000001111111000000100000000000000000000000000000',
    '000000000000000000000000000000000000000000001111000000000000000000000000000000000111111111111111111111111111111111100000000000011100000000011111000000100000000000000000000000000000',
    '000000000000000000000000000000000000000000000011000000000000000000000000000000000111111111111111111111111111111110000000000000011100000000011111100000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000001000001110010000000000000000000000011111111111111111111111111111101110000000000001100000000010111000001011000000000000000000000000000',
    '000000000000000000000000000000000000000000000000111111111111000000000000000000000001111111111111111111111111111111100000000000001010000000010000000001011000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000111111111100000000000000000000000111111111111111111111111111111100000000000000010000000001000000000011000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000111111111111100000000000000000000001111001111111111111111111111000000000000000000000000101100000110000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000111111111111110000000000000000000000000000001111111111111111110000000000000000000000000110100001110000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000001111111111111110000000000000000000000000000001111111111111111100000000000000000000000000011000111110111000000000000000000000000000',
    '000000000000000000000000000000000000000000000000001111111111111111100000000000000000000000000011111111111111111000000000000000000000000000001100011111100000100000000000000000000000',
    '000000000000000000000000000000000000000000000000001111111111111111111100000000000000000000000001111111111111110000000000000000000000000000000110011111100000111110000000000000000000',
    '000000000000000000000000000000000000000000000000011111111111111111111111000000000000000000000000111111111111110000000000000000000000000000000010000001100000001111101100000000000000',
    '000000000000000000000000000000000000000000000000001111111111111111111111100000000000000000000000111111111111110000000000000000000000000000000001111000000000000111110000000000000000',
    '000000000000000000000000000000000000000000000000000111111111111111111111000000000000000000000000111111111111110000000000000000000000000000000000001011101000000011011000000000000000',
    '000000000000000000000000000000000000000000000000000111111111111111111111000000000000000000000000011111111111110000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000011111111111111111110000000000000000000000000111111111111111000100000000000000000000000000000000000000001110001000000000000000000',
    '000000000000000000000000000000000000000000000000000011111111111111111110000000000000000000000000111111111111110001100000000000000000000000000000000000001111110001100000000000000000',
    '000000000000000000000000000000000000000000000000000000111111111111111110000000000000000000000000111111111111110011100000000000000000000000000000000000011111111111100000000000000010',
    '000000000000000000000000000000000000000000000000000000011111111111111100000000000000000000000000111111111111000011100000000000000000000000000000000000111111111111110000000000000000',
    '000000000000000000000000000000000000000000000000000000011111111111111100000000000000000000000000011111111111000011000000000000000000000000000000000011111111111111111000000010000000',
    '000000000000000000000000000000000000000000000000000000011111111111111000000000000000000000000000011111111111000011000000000000000000000000000000000111111111111111111100000000000000',
    '000000000000000000000000000000000000000000000000000000011111111111000000000000000000000000000000011111111110000010000000000000000000000000000000000111111111111111111100000000000000',
    '000000000000000000000000000000000000000000000000000000111111111111000000000000000000000000000000001111111110000000000000000000000000000000000000000111111111111111111110000000000000',
    '000000000000000000000000000000000000000000000000000000111111111110000000000000000000000000000000001111111100000000000000000000000000000000000000000111111111111111111110000000000000',
    '000000000000000000000000000000000000000000000000000000111111111110000000000000000000000000000000000111111000000000000000000000000000000000000000000111111111111111111110000000000000',
    '000000000000000000000000000000000000000000000000000000111111111100000000000000000000000000000000000111110000000000000000000000000000000000000000000011111000011111111100000000000000',
    '000000000000000000000000000000000000000000000000000000111111110000000000000000000000000000000000000000000000000000000000000000000000000000000000000010000000000111111000000000001000',
    '000000000000000000000000000000000000000000000000000001111111110000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000011111000000000000110',
    '000000000000000000000000000000000000000000000000000001111111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000110',
    '000000000000000000000000000000000000000000000000000001111100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000110000000000001100',
    '000000000000000000000000000000000000000000000000000001111100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000010000000000011000',
    '000000000000000000000000000000000000000000000000000011111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001110000',
    '000000000000000000000000000000000000000000000000000011111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000',
    '000000000000000000000000000000000000000000000000000011111000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000011110001100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000001110000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
    '000000000000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'
  ];
  // The land as one SVG path of the mask's cells in world units (longitude x 0.77, minus latitude), so a view moves it with a single transform.
  var LAND = '';
  LAND_ROWS.forEach(function (row, r) {
    for (var c = 0; c < row.length; c++) if (row.charAt(c) === '1') LAND += 'M' + Math.round((-179 + 2 * c) * 77) / 100 + ' ' + -(89 - 2 * r) + 'h0';
  });
  // Per layout: the designed map frame (scaled to the measured box), map word metrics, greeting size, and views as
  // [centre longitude, centre latitude, pixels per degree at the designed frame]. W is the whole constellation for search.
  // Every frame a visitor can see holds at least 12 delivery dots; Americas countries open on an Atlantic view (SUMMARY.C).
  var LAYOUTS = {
    desktop: { mobile: false, base: { w: 632, h: 452 }, label: { font: 14, h: 28, pad: 6, off: 14 }, greetMax: 64, greetWidth: 600, lean: false,
      views: { E: [10, 50.5, 12], M: [44, 31, 12], A: [125, -2, 5.5], C: [-78, 26, 14], W: [37, 12, 2.9] }, summary: { C: [-40, 38, 5.5] } },
    mobile: { mobile: true, base: { w: 342, h: 236 }, label: { font: 14, h: 44, pad: 4, off: 14 }, greetMax: 48, greetWidth: 342, lean: true,
      views: { E: [12, 51, 7], M: [44, 31, 6], A: [125, 0, 2.6], C: [-78, 26, 8.5], W: [37, 12, 1.55] }, summary: { C: [-36, 38, 3.2] },
      // The country step shows a dots-only strip above the search.
      strip: { w: 342, h: 104, views: { E: [12, 50, 3.1], M: [44, 30, 4.4], A: [125, -2.5, 1.2], C: [-78, 25.5, 3.3], W: [37, 11.7, 0.88] } } }
  };
  // Search: lower case without accents or punctuation, "&" as "and", "saint" as "st" (Shopify writes "St. Lucia").
  function fold(text) { return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/&/g, ' and ').replace(/[.,'’-]/g, '').replace(/\s+/g, ' ').trim().replace(/(^| )saint /g, '$1st '); }
  // Countries matching a query by name or alias. Exact ISO codes and exact alias words rank first, so "us" lists the United States
  // and "uk" the United Kingdom on top; the rest keep their given order. A blank query matches nothing.
  function searchCountries(countries, query) {
    var qf = fold(query);
    if (!qf) return [];
    var code = query.trim().toUpperCase();
    return countries.map(function (c) {
      var alias = fold(ALIASES[c.code] || '');
      var exact = c.code === code || alias.split(' ').indexOf(qf) !== -1;
      return exact || fold(c.name).indexOf(qf) !== -1 || alias.indexOf(qf) !== -1 ? { c: c, rank: exact ? 0 : 1 } : null;
    }).filter(Boolean).sort(function (a, b) { return a.rank - b.rank; }).map(function (hit) { return hit.c; });
  }

  // Under Node (scripts/check-localization-search.cjs) only the pure helpers load; everything below needs the page.
  if (typeof module === 'object' && module.exports) {
    module.exports = { fold: fold, searchCountries: searchCountries };
    return;
  }

  var dialog = document.getElementById('AmeoroLocalization');
  // Loaded on demand by the inline loader in snippets/ameoro-localization.liquid, which already hid every opener without <dialog>.
  if (!dialog || typeof dialog.showModal !== 'function' || !window.AmeoroGreetings) return;
  var CFG = JSON.parse(document.getElementById('AmeoroLocalizationData').textContent);
  // The dialog's words (snippets/ameoro-localization-strings.liquid) by language: the page's, then each picked one once fetched.
  var STRINGS = {};
  STRINGS[CFG.language] = CFG.strings;
  var T, COUNTRIES, tLang;
  // Welcome words, spoken languages and the greeting rules: assets/ameoro-greetings.js, inlined by the greeting strip.
  var G = window.AmeoroGreetings;
  var form = dialog.querySelector('form');
  function q(sel) { return dialog.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(dialog.querySelectorAll(sel)); }
  var wide = window.matchMedia('(min-width: 1024px)');
  var L = wide.matches ? LAYOUTS.desktop : LAYOUTS.mobile;

  // Liquid hands names over HTML-escaped ("Turks &amp; Caicos Islands"); decode once, escape again when rendering.
  var decoder = document.createElement('textarea');
  function decode(text) { decoder.innerHTML = text; return decoder.value; }
  // Speak a language whose strings are loaded: its words, country names and lang. No dir: the texts carry dir=auto, and a
  // mirrored layout (page-wide RTL) is out of scope; the Arabic and Hebrew pages are laid out left to right too.
  function use(lc) {
    tLang = lc;
    T = STRINGS[lc];
    COUNTRIES = T.countries.map(function (c) {
      // A live country without a centroid still lists (under Europe until it gets data), it just has no dot.
      return { code: c.code, name: decode(c.name), market: G.market(c.code), region: REGION[c.code] || 'E' };
    });
    form.lang = lc;
  }
  use(CFG.language);
  var LANGS = CFG.languages.map(function (l) {
    // Shopify endonyms are lower case with a region ("português (Portugal)"); the selector shows "Português".
    var n = decode(l.name).split(' (')[0];
    return { code: l.code, name: n.charAt(0).toUpperCase() + n.slice(1), url: l.url };
  });
  var COLLATOR = new Intl.Collator(document.documentElement.lang || 'en');
  // A code missing from the list still renders, under its code and the first country's region.
  function find(code) { return COUNTRIES.filter(function (c) { return c.code === code; })[0] || { code: code, name: code, market: G.market(code), region: COUNTRIES[0].region }; }
  function lang(code) { return LANGS.filter(function (l) { return l.code === code; })[0]; }
  function spoken(country) { return G.spokenIn(country).filter(lang); }
  function dirOf(code) { return code === 'he' || code === 'ar' ? 'rtl' : 'ltr'; }
  function esc(text) { return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  var PUBLISHED = LANGS.map(function (l) { return l.code; });
  function greetFor(country) { return G.greetFor(country, navigator.languages || [navigator.language || ''], PUBLISHED); }
  function chipRow(country, saved, checked, suggest) { return G.chipRow(country, saved, checked, suggest, PUBLISHED); }
  // English has no single home here: for a country without one of our languages, "Welcome" sits on that country.
  function anchorOf(code, picked) {
    // A country without a centroid puts "Welcome" over Britain.
    if (code === 'en' && !spoken(picked).length) return LL[picked] || LL.GB;
    if (code === 'ar') return GULF;
    return LL[HOME[code]];
  }
  // Equirectangular with a 40 degree standard parallel (cos 40 = 0.77); v is [centre longitude, centre latitude, pixels per degree].
  function px(lon, v, m) { return Math.round((m.w / 2 + (lon - v[0]) * 0.77 * v[2]) * 10) / 10; }
  function py(lat, v, m) { return Math.round((m.h / 2 - (lat - v[1]) * v[2]) * 10) / 10; }
  function homeView(code) {
    var c = find(code);
    if (L.summary[c.region]) return L.summary[c.region];
    var v = L.views[c.region];
    // On the phone crop the summary view leans halfway from the region centre toward the chosen country.
    return L.lean && LL[code] ? [(v[0] + LL[code][0]) / 2, (v[1] + LL[code][1]) / 2, v[2]] : v;
  }
  // shortcut: word widths are estimated at 0.56em per character, not measured; measure with canvas measureText if labels ever clip.
  function est(word) { return Math.ceil(Array.from(word).length * L.label.font * 0.56); }

  // Which words show: the visitor's own languages (the suggestion, then the country's languages), then the NEAR words closest
  // to the chosen country; other spots in view are hover dots. Greedy placement: a word tries spots around its anchor and is
  // kept only if it fits the map and touches no other shown word or the chosen country's ring. The layout depends on the view
  // and the chosen country only, so a language change never moves a word.
  function placeLabels(view, m, picked, suggest) {
    var LB = L.label;
    var own = [suggest].concat(spoken(picked)).filter(function (c, i, all) { return all.indexOf(c) === i; });
    var sp = LL[picked];
    var sx = sp ? px(sp[0], view, m) : -999;
    var sy = sp ? py(sp[1], view, m) : -999;
    var taken = [[sx - 11, sy - 11, 22, 22, '']];
    var out = {};
    var near = 0;
    function inside(b) { return b[0] >= 0 && b[1] >= 0 && b[0] + b[2] <= m.w && b[1] + b[3] <= m.h; }
    function clear(b, code) { return taken.every(function (t) { return t[4] === code || b[0] >= t[0] + t[2] || t[0] >= b[0] + b[2] || b[1] >= t[1] + t[3] || t[1] >= b[1] + b[3]; }); }
    var cands = LANGS.filter(function (l) { return G.words[l.code] && anchorOf(l.code, picked); }).map(function (l) {
      var a = anchorOf(l.code, picked);
      var x = px(a[0], view, m);
      var y = py(a[1], view, m);
      var o = own.indexOf(l.code);
      return { code: l.code, a: a, x: x, y: y, rank: o !== -1 ? o - 100 : Math.hypot(x - sx, y - sy) };
    });
    // On desktop a shown word keeps clear of the other spots too, so every hover dot stays reachable; on touch the dots are decoration.
    if (!L.mobile) cands.forEach(function (c) { taken.push([c.x - 6, c.y - 6, 12, 12, c.code]); });
    cands.sort(function (p, r) { return p.rank - r.rank; }).forEach(function (c) {
      var w = est(G.words[c.code] + (TWIN[c.code] ? ' ' + TWIN[c.code] : '')) + 2 * LB.pad;
      var h = LB.h;
      // A word on the chosen country itself stands clear of its ring.
      var ringed = c.a === sp;
      var o = ringed ? 11 + h / 2 : LB.off;
      var g = ringed ? 12 : 6;
      // [x, centre y, share of the width left of x]: above, below, right, left, then above and below nudged a third of the word sideways.
      var spots = [[c.x, c.y - o, 0.5], [c.x, c.y + o, 0.5], [c.x + g, c.y, 0], [c.x - g, c.y, 1], [c.x + w / 3, c.y - o, 0.5], [c.x - w / 3, c.y - o, 0.5], [c.x + w / 3, c.y + o, 0.5], [c.x - w / 3, c.y + o, 0.5]];
      function box(sp2) { return [sp2[0] - w * sp2[2], sp2[1] - h / 2, w, h]; }
      var fits = spots.filter(function (sp2) { return inside(box(sp2)); });
      var free = fits.filter(function (sp2) { return clear(box(sp2), c.code); });
      var inView = c.x >= 0 && c.x <= m.w && c.y >= 0 && c.y <= m.h;
      var show = inView && free.length > 0 && (c.rank < 0 || near < NEAR);
      var spot = free[0] || fits[0] || spots[0];
      if (show) { taken.push(box(spot).concat('')); if (c.rank >= 0) near++; }
      out[c.code] = { x: spot[0], y: spot[1] - h / 2, shift: (-100 * spot[2]) + '%', mx: Math.round((c.x - spot[0]) * 10) / 10, my: Math.round((c.y - spot[1] + h / 2) * 10) / 10, vis: !inView ? 'none' : show ? 'show' : 'peek' };
    });
    return out;
  }

  // Elements that stay mounted: the map moves them with transitions instead of rebuilding them.
  var head = document.getElementById('AmeoroG2Head');
  var ghost = document.getElementById('AmeoroG2Ghost');
  var greetSr = document.getElementById('AmeoroG2Greet');
  var mapBox = q('.g2-map');
  var frameEl = q('.g2-map__frame');
  var land = q('.g2-land');
  var landG = land.querySelector('g');
  land.querySelector('path').setAttribute('d', LAND);
  var dotsEl = q('.g2-dots');
  var wordsEl = q('.g2-words');
  var caption = q('.g2-caption');
  var chipsEl = q('.g2-chips');
  var moreBtn = q('[data-g2-more]');
  var moreList = q('.g2-morelist');
  var pendingEl = q('.g2-pending');
  var search = q('[data-g2-search]');
  var countEl = q('[data-g2-count]');
  var tablist = q('.g2-tabs');
  var tabs = qa('.g2-tab');
  var ink = q('.g2-ink');
  var listEl = q('.g2-list');
  var rowsEl = listEl.querySelector('ul');
  var noMatch = q('.g2-nomatch');
  var REGIONS = tabs.map(function (t) { return t.getAttribute('data-region'); });
  var dots = {};
  COUNTRIES.forEach(function (c) {
    if (!LL[c.code]) return;
    var d = document.createElement('span');
    d.className = 'g2-dot g2-pan';
    d.innerHTML = '<span class="g2-pt"></span>';
    dotsEl.appendChild(d);
    dots[c.code] = d;
  });
  var words = {};
  LANGS.forEach(function (l) {
    if (!G.words[l.code]) return;
    var w = document.createElement('span');
    w.className = 'g2-word g2-pan';
    w.setAttribute('data-lang', l.code);
    w.innerHTML = '<span class="g2-hit"><span lang="' + l.code + '" dir="' + dirOf(l.code) + '">' + esc(G.words[l.code]) + '</span>' + (TWIN[l.code] ? '<span class="g2-tag">' + TWIN[l.code] + '</span>' : '') + '</span><span class="g2-spot"></span>';
    wordsEl.appendChild(w);
    words[l.code] = w;
  });
  var ring = document.createElement('span');
  ring.className = 'g2-sel';
  ring.innerHTML = '<span class="g2-sel__dot"></span><svg width="22" height="22" viewBox="0 0 22 22"><circle class="g2-ring" cx="11" cy="11" r="9" fill="none" stroke="#C7A955" stroke-width="1.5"></circle></svg>';

  var saved = { country: CFG.country, lang: CFG.language };
  var s = null;
  var placed = {};
  var lastStep = 'summary';
  var lastFrame = '';
  var ringOn = null;
  var focusId = null;
  // The move: fly is the start point (null crossfades in place, 'slot' measures the greeting's map word after render); ghost fades the previous word out.
  var flyPending = false;
  var fly = null;
  var flyDelay = 0;
  var ghostPending = false;
  var trigger = null;

  function setState(patch) { for (var k in patch) s[k] = patch[k]; render(); }
  // Text (live regions too) changes only when it differs, so a screen reader is not re-told on every key.
  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
  function setHtml(el, html) { if (el.getAttribute('data-html') !== html) { el.innerHTML = html; el.setAttribute('data-html', html); } }
  function setWord(el, code) {
    var w = G.words[code] ? code : 'en';
    // Josefin Sans averages about 0.6em per character: size caps the word at the headline width, em lets CSS shrink it to the stage (100cqw).
    var em = Array.from(G.words[w]).length * 0.6;
    if (el.textContent !== G.words[w]) el.textContent = G.words[w];
    el.lang = w;
    el.dir = dirOf(w);
    el.style.fontSize = 'min(' + Math.min(L.greetMax, Math.floor(L.greetWidth / em)) + 'px, calc(100cqw / ' + Math.round(em * 100) / 100 + '))';
  }

  // The frame is the designed one scaled to the measured box, so nothing is cut at 320px, on a short laptop screen or at 768px.
  function measure(countryStep) {
    var strip = L.strip && countryStep;
    var base = strip ? L.strip : L.base;
    var w = mapBox.clientWidth || base.w;
    if (L.mobile) {
      var k = w / base.w;
      // A short sheet crops the map height (same scale, centred) so the language chips stay on the first screen.
      var mh = Math.round(base.h * k);
      return { w: w, h: strip || !mapCap ? mh : Math.min(mh, mapCap), k: k, views: strip ? L.strip.views : L.views };
    }
    w = Math.min(w, base.w);
    var h = Math.min(base.h, mapBox.clientHeight || base.h);
    return { w: w, h: h, k: Math.min(w / base.w, h / base.h), views: L.views };
  }

  function renderMap(countryStep, world, shown, suggest) {
    var m = measure(countryStep);
    var key = m.w + 'x' + m.h;
    // A new frame (opening, the phone's country strip, a resize) jumps into place; a view change inside one frame pans.
    var still = key !== lastFrame;
    lastFrame = key;
    if (still) mapBox.classList.add('g2-still');
    mapBox.style.height = L.mobile ? m.h + 'px' : '';
    frameEl.style.width = m.w + 'px';
    frameEl.style.height = m.h + 'px';
    frameEl.style.marginTop = -m.h / 2 + 'px';
    land.style.width = m.w + 'px';
    land.style.height = m.h + 'px';
    var v0 = world ? m.views.W : countryStep ? m.views[s.region] : homeView(s.picked);
    var view = [v0[0], v0[1], v0[2] * m.k];
    landG.style.transform = 'translate(' + Math.round((m.w / 2 - view[0] * 0.77 * view[2]) * 10) / 10 + 'px, ' + Math.round((m.h / 2 + view[1] * view[2]) * 10) / 10 + 'px) scale(' + view[2] + ')';
    Object.keys(dots).forEach(function (code) {
      var d = dots[code];
      d.style.transform = 'translate(' + px(LL[code][0], view, m) + 'px, ' + py(LL[code][1], view, m) + 'px)';
      d.firstChild.style.background = world && shown[code] ? '#222222' : '#C7A955';
    });
    if (still || ringOn !== s.picked) {
      // Re-inserting the ring replays its draw.
      if (ring.parentNode) ring.parentNode.removeChild(ring);
      ringOn = s.picked;
      ring.querySelector('circle').style.animationDelay = s.ringDelay + 'ms';
      if (dots[s.picked]) dots[s.picked].appendChild(ring);
    }
    placed = placeLabels(view, m, s.picked, suggest);
    var LB = L.label;
    Object.keys(words).forEach(function (code) {
      var p = placed[code];
      var w = words[code];
      // A word without a spot on this map (its anchor has no centroid) stays hidden.
      if (!p) { w.style.opacity = 0; w.firstChild.style.pointerEvents = w.lastChild.style.pointerEvents = 'none'; return; }
      if (countryStep) p.vis = 'none';
      var isHead = code === s.greet;
      // The greeting's word leaves the map at once (it is the headline now); the word it replaced returns after the move lands.
      var on = p.vis !== 'none' && !isHead;
      var peek = p.vis === 'peek';
      w.className = 'g2-word g2-pan ' + (peek ? 'g2-peek' : 'g2-show');
      w.style.transform = 'translate(' + p.x + 'px, ' + p.y + 'px)';
      w.style.opacity = on ? 1 : 0;
      w.style.transition = 'transform 700ms ' + MOVE + ', opacity ' + (isHead ? 0 : 300) + 'ms linear ' + (code === s.prevGreet ? s.returnDelay : 0) + 'ms';
      var hit = w.firstChild;
      hit.style.pointerEvents = on && !peek ? 'auto' : 'none';
      hit.style.height = hit.style.lineHeight = LB.h + 'px';
      hit.style.padding = '0 ' + LB.pad + 'px';
      hit.style.transform = 'translateX(' + p.shift + ')';
      var spot = w.lastChild;
      spot.style.left = p.mx + 'px';
      spot.style.top = p.my + 'px';
      spot.style.pointerEvents = on && peek && !L.mobile ? 'auto' : 'none';
    });
    if (still) {
      void mapBox.offsetWidth;
      mapBox.classList.remove('g2-still');
    }
  }

  function render() {
    var chosen = find(s.picked);
    var countryStep = s.step === 'country';
    dialog.setAttribute('data-step', s.step);
    var qf = fold(s.query);
    var suggest = greetFor(s.picked);
    var hits = qf ? searchCountries(COUNTRIES, s.query) : COUNTRIES.filter(function (c) { return c.region === s.region; });
    var shown = {};
    hits.forEach(function (c) { shown[c.code] = true; });

    setWord(head, s.greet);
    setWord(ghost, s.prevGreet || s.greet);
    setWord(greetSr, s.greet);
    greetSr.style.fontSize = '';
    qa('[data-g2-t]').forEach(function (el) { var k = el.getAttribute('data-g2-t'); if (/Html$/.test(k)) setHtml(el, T[k]); else setText(el, T[k]); });
    qa('[data-g2-label]').forEach(function (el) { el.setAttribute('aria-label', T[el.getAttribute('data-g2-label')]); });
    search.placeholder = T.search;
    var name = G.countryName(chosen.code, chosen.name, T.english);
    qa('[data-g2-deliver]').forEach(function (el) { setText(el, T.deliver.replace('%country%', name)); });
    qa('[data-g2-note]').forEach(function (el) { setText(el, T['note' + chosen.market]); });

    renderMap(countryStep, countryStep && qf !== '', shown, suggest);
    // Under the map: the tap hint on the summary (decorative, like the map), the delivery fact on the country step.
    setText(caption, countryStep ? T.deliveryCount : T.mapHint);
    caption.setAttribute('aria-hidden', countryStep ? 'false' : 'true');

    setHtml(chipsEl, s.chips.map(function (lc) {
      var on = lc === s.lang;
      var hint = G.isSuggested(lc, s.lang, suggest);
      return '<button type="button" class="g2-chip" id="AmeoroG2Chip-' + lc + '" role="radio" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-lang="' + lc + '">' + (on ? CHECK : '') +
        '<span lang="' + lc + '" dir="' + dirOf(lc) + '">' + esc(lang(lc).name) + '</span>' + (hint ? '<span class="g2-chip__hint">' + esc(T.suggested) + '</span>' : '') + '</button>';
    }).join(''));
    // Nothing more to offer when every published language is already a chip.
    moreBtn.hidden = s.chips.length >= LANGS.length;
    moreBtn.setAttribute('aria-expanded', s.showMore ? 'true' : 'false');
    moreList.hidden = !s.showMore;
    setHtml(moreList, s.showMore ? LANGS.filter(function (l) { return s.chips.indexOf(l.code) === -1; }).sort(function (a, b) { return COLLATOR.compare(a.name, b.name); }).map(function (l) {
      return '<li><button type="button" class="g2-moreitem" data-lang="' + l.code + '"><span lang="' + l.code + '" dir="' + dirOf(l.code) + '">' + esc(l.name) + '</span></button></li>';
    }).join('') : '');
    var dirty = s.picked !== s.saved.country || s.lang !== s.saved.lang;
    setText(pendingEl, dirty ? T.pending : '');

    if (search.value !== s.query) search.value = s.query;
    tablist.hidden = !!qf;
    var ri = REGIONS.indexOf(s.region);
    tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === ri ? 'true' : 'false'); t.tabIndex = i === ri ? 0 : -1; });
    ink.style.transform = 'translateX(' + 100 * ri + '%)';
    listEl.setAttribute('role', qf ? 'region' : 'tabpanel');
    listEl.setAttribute('aria-label', qf ? T.searchResults : tabs[ri].textContent);
    setHtml(rowsEl, hits.map(function (c) {
      var on = c.code === s.picked;
      return '<li><button type="button" class="g2-row" aria-current="' + on + '" data-r="' + c.code + '"><span>' + esc(c.name) + '</span>' + (on ? CHECK : '') + '</button></li>';
    }).join(''));
    noMatch.hidden = hits.length !== 0;
    setText(noMatch.querySelector('[data-g2-query]'), s.query);
    setText(countEl, hits.length === 1 ? T.countOne : T.countOther.replace('%n%', hits.length));

    form.elements.country_code.value = s.picked;
    form.elements.language_code.value = s.lang;

    // Step changes move focus deliberately, never to <body>: the new step's heading, or back to the delivery line.
    var id = focusId;
    var scroll = !id;
    focusId = null;
    if (s.step !== lastStep) {
      lastStep = s.step;
      id = countryStep ? 'AmeoroG2CountryTitle' : 'AmeoroG2Dest';
      scroll = true;
    }
    var el = id ? document.getElementById(id) : null;
    if (el) el.focus({ preventScroll: !scroll });
    playFly();
  }

  // The centre of a map word as drawn now, or null when its spot is not on the visible map.
  function capture(code) {
    var p = placed[code];
    if (!p || p.vis === 'none' || !words[code]) return null;
    var r = words[code].firstChild.firstChild.getBoundingClientRect();
    return r.width ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : null;
  }
  // The signature move: the headline starts at its map word's position and size and travels up into place. State has already changed; this only decorates it.
  function playFly() {
    if (!flyPending) return;
    flyPending = false;
    if (typeof head.animate !== 'function') return;
    var from = fly === 'slot' ? capture(s.greet) : fly;
    var delay = flyDelay;
    fly = null;
    flyDelay = 0;
    head.getAnimations().forEach(function (a) { a.cancel(); });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Chips, the More list, a country change and a word off the map crossfade in 200ms; only the first open and a map tap fly.
    if (ghostPending && !reduce) ghost.animate([{ opacity: 1 }, { opacity: 0 }], { duration: from ? 180 : 200, easing: MOVE });
    ghostPending = false;
    if (reduce) { head.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 150, easing: 'linear' }); return; }
    if (!from) { head.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, delay: delay, easing: ARRIVE, fill: 'backwards' }); return; }
    var r = head.getBoundingClientRect();
    var dx = from.x - (r.left + r.width / 2);
    var dy = from.y - (r.top + r.height / 2);
    var k = L.label.font / (parseFloat(getComputedStyle(head).fontSize) || L.greetMax);
    head.animate([{ transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + k + ')' }, { transform: 'none' }], { duration: 800, delay: delay, easing: MOVE, fill: 'backwards' });
  }

  // A language pick checks the chip and greets in it. A map tap flies the word into the headline; chips, arrow keys and the More list crossfade.
  function pickLang(lc, how) {
    if (lc === s.lang && lc === s.greet) return;
    if (how === 'more') { q('.g2-scroll').scrollTop = 0; form.scrollTop = 0; }
    var moves = lc !== s.greet;
    if (moves) { flyPending = true; fly = how === 'map' ? capture(lc) : null; ghostPending = true; }
    focusId = 'AmeoroG2Chip-' + lc;
    setState({ lang: lc, greet: lc, langPicked: true, prevGreet: moves ? s.greet : s.prevGreet, returnDelay: how === 'map' ? 520 : 0, showMore: how === 'more' ? false : s.showMore, chips: s.chips.indexOf(lc) === -1 ? s.chips.slice(0, 3).concat(lc) : s.chips });
    speak(lc);
  }
  // The dialog speaks a picked language before Save (L1-L6). A failed or odd reply keeps the current words; Save still applies the pick.
  function speak(lc) {
    if (lc === tLang) return;
    if (!STRINGS[lc]) {
      fetch(lang(lc).url.replace(/\/?$/, '/') + '?sections=ameoro-localization-strings').then(function (r) { return r.json(); }).then(function (j) {
        STRINGS[lc] = JSON.parse(new DOMParser().parseFromString(j['ameoro-localization-strings'], 'text/html').querySelector('script').textContent);
        // Only the language still picked when the reply lands.
        if (dialog.open && s.lang === lc) speak(lc);
      }).catch(function () {});
      return;
    }
    use(lc);
    render();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) qa('[data-g2-t], [data-g2-deliver], [data-g2-note], .g2-caption, .g2-list ul').forEach(function (el) { el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: ARRIVE }); });
  }
  function pickCountry(code) {
    if (code === s.picked) { setState({ step: 'summary', query: '' }); return; }
    var sug = greetFor(code);
    // Until the visitor picks a language in this panel, the greeting follows the country.
    var g = s.langPicked ? s.greet : sug;
    if (g !== s.greet) { flyPending = true; fly = null; ghostPending = true; }
    setState({ picked: code, step: 'summary', query: '', greet: g, prevGreet: g !== s.greet ? s.greet : null, returnDelay: 0, ringDelay: 250, chips: chipRow(code, s.saved.lang, s.lang, sug) });
  }
  function pickRegion(rc) { focusId = 'AmeoroG2Tab' + rc; setState({ region: rc }); }

  // Phone sheet: shrink the map until the chips clear the sticky Save on the first screen (320x640, 375x667). Measured on
  // the rendered summary; true when the cap changed and the caller must render again (a warm open keeps the last cap).
  var mapCap = 0;
  function fitSheet() {
    var cap = 0;
    if (L.mobile) {
      // The country step hides the chips: keep the cap for the way back.
      if (!chipsEl.getClientRects().length) return false;
      var full = Math.round(L.base.h * (mapBox.clientWidth || L.base.w) / L.base.w);
      var over = chipsEl.getBoundingClientRect().bottom + 8 - q('.g2-footer').getBoundingClientRect().top + full - mapBox.offsetHeight;
      if (over > 0) cap = Math.max(96, full - Math.ceil(over));
    }
    if (cap === mapCap) return false;
    mapCap = cap;
    return true;
  }
  function home() {
    // The visible header button: the strip's Change may be gone by the time the dialog closes.
    return Array.prototype.filter.call(document.querySelectorAll('.ameoro-localization-trigger'), function (b) { return b.getClientRects().length; })[0];
  }
  var savedEl = document.getElementById('AmeoroG2Saved');
  function announceSaved() {
    var l = lang(saved.lang);
    savedEl.textContent = '';
    setTimeout(function () { savedEl.textContent = T.saved.replace('%country%', find(saved.country).name).replace('%language%', l ? l.name : saved.lang); }, 400);
  }
  function setExpanded(value) { document.querySelectorAll('[aria-controls="AmeoroLocalization"]').forEach(function (b) { b.setAttribute('aria-expanded', value); }); }
  function open() {
    var first = true;
    // Blocked storage: the greeting flies on every open instead of once per session, which is harmless.
    try { first = !sessionStorage.getItem('ameoro-g2-flown'); sessionStorage.setItem('ameoro-g2-flown', '1'); } catch (error) {}
    L = wide.matches ? LAYOUTS.desktop : LAYOUTS.mobile;
    var g = greetFor(saved.country);
    s = { step: 'summary', picked: saved.country, lang: saved.lang, greet: g, langPicked: false, saved: saved, chips: chipRow(saved.country, saved.lang, saved.lang, g), showMore: false, region: find(saved.country).region, query: '', prevGreet: null, returnDelay: 0, ringDelay: first ? 760 : 300 };
    lastStep = 'summary';
    lastFrame = '';
    // Every open starts in the saved language, the page's.
    if (tLang !== saved.lang) use(saved.lang);
    if (!dialog.open) dialog.showModal();
    setExpanded('true');
    form.scrollTop = 0;
    q('.g2-scroll').scrollTop = 0;
    render();
    if (fitSheet()) render();
    // The greeting flies from its map word on the first open of the session; later opens show it settled.
    if (first) { flyPending = true; fly = 'slot'; flyDelay = 160; playFly(); }
    document.getElementById('AmeoroLocalizationTitle').focus({ preventScroll: true });
  }

  // Called by the inline loader (snippets/ameoro-localization.liquid) once this script and its stylesheet have loaded.
  // Not window.AmeoroLocalization: that name is the dialog (its id).
  window.AmeoroSelector = {
    open: function (opener) {
      trigger = opener;
      open();
      // The strip's Change has done its job once the dialog is open (same key as snippets/ameoro-greeting-strip.liquid).
      var strip = document.getElementById('AmeoroGreetingStrip');
      if (strip && strip.contains(opener)) {
        // A rare quota error: the strip just hides for this page.
        try { localStorage.setItem('ameoro-greeting-seen', '1'); } catch (error) {}
        strip.hidden = true;
      }
    }
  };
  // Back after Save can restore this page from the back-forward cache with the dialog still open: start closed.
  window.addEventListener('pageshow', function (event) { if (event.persisted && dialog.open) dialog.close(); });
  dialog.addEventListener('click', function (event) {
    var t = event.target;
    var el;
    // The second click of a double click on an opener lands on the scrim of the dialog it just opened: keep it open.
    if (t.closest('[data-g2-close]')) { if (!(event.detail > 1 && t.classList.contains('g2-scrim'))) dialog.close(); }
    else if (t.closest('[data-g2-countries]')) setState({ step: 'country', region: find(s.picked).region, query: '' });
    else if (t.closest('[data-g2-back]')) setState({ step: 'summary', query: '' });
    else if (t.closest('[data-g2-more]')) {
      setState({ showMore: !s.showMore });
      // On the sheet the list opens below the fold, behind the sticky Save: bring the language section up under the title.
      if (s.showMore && L.mobile) q('.g2-langhead').scrollIntoView({ block: 'start' });
    }
    else if ((el = t.closest('.g2-chip'))) pickLang(el.getAttribute('data-lang'), 'chip');
    else if ((el = t.closest('.g2-moreitem'))) pickLang(el.getAttribute('data-lang'), 'more');
    else if ((el = t.closest('.g2-tab'))) pickRegion(el.getAttribute('data-region'));
    else if ((el = t.closest('[data-r]'))) pickCountry(el.getAttribute('data-r'));
    else if ((el = t.closest('.g2-hit, .g2-spot'))) pickLang(el.parentNode.getAttribute('data-lang'), 'map');
  });
  // Radio group keys (WAI-ARIA APG): one Tab stop, arrows move and select, Home and End jump. Selecting only previews; Save applies.
  chipsEl.addEventListener('keydown', function (e) {
    var n = s.chips.length;
    var i = s.chips.indexOf(s.lang);
    var k = e.key;
    var rtl = getComputedStyle(e.target).direction === 'rtl';
    var j = k === 'ArrowDown' || k === (rtl ? 'ArrowLeft' : 'ArrowRight') ? (i + 1) % n : k === 'ArrowUp' || k === (rtl ? 'ArrowRight' : 'ArrowLeft') ? (i + n - 1) % n : k === 'Home' ? 0 : k === 'End' ? n - 1 : -1;
    if (j === -1) return;
    e.preventDefault();
    pickLang(s.chips[j], 'chip');
  });
  // Tabs (WAI-ARIA APG, automatic activation): arrows move and select, Home and End jump.
  tablist.addEventListener('keydown', function (e) {
    var i = REGIONS.indexOf(s.region);
    var n = REGIONS.length;
    var k = e.key;
    var j = k === 'ArrowRight' ? (i + 1) % n : k === 'ArrowLeft' ? (i + n - 1) % n : k === 'Home' ? 0 : k === 'End' ? n - 1 : -1;
    if (j === -1) return;
    e.preventDefault();
    pickRegion(REGIONS[j]);
  });
  search.addEventListener('input', function () { setState({ query: search.value }); });
  // Enter in the search box must not submit the localization form.
  search.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  // A hovered or focused country row marks its dot.
  function hot(e) {
    var row = e.type === 'pointerout' || e.type === 'focusout' ? null : e.target.closest('[data-r]');
    Object.keys(dots).forEach(function (code) { dots[code].classList.toggle('g2-hot', !!row && row.getAttribute('data-r') === code); });
  }
  ['pointerover', 'pointerout', 'focusin', 'focusout'].forEach(function (type) { rowsEl.addEventListener(type, hot); });
  // Esc steps back from the country list, otherwise it closes. A repeated Esc can arrive non-cancelable: then it closes.
  dialog.addEventListener('cancel', function (e) {
    if (s && s.step === 'country' && e.cancelable) { e.preventDefault(); setState({ step: 'summary', query: '' }); }
  });
  // Close, Esc and the scrim discard the draft; the platform returns focus to the opener.
  dialog.addEventListener('close', function () {
    setExpanded('false');
    // When the opener has gone (the strip hides on Change), focus is still on the closed dialog here and would drop to <body>.
    var a = document.activeElement;
    if (!a || a === document.body || dialog.contains(a)) {
      var back = trigger && trigger.getClientRects().length ? trigger : home();
      if (back) back.focus();
    }
  });
  form.addEventListener('submit', function (e) {
    try {
      // Shares the key with assets/ameoro-locale-redirect.js so a manual choice is never overridden by geolocation.
      localStorage.setItem('ameoro-locale-chosen', 'manual');
      localStorage.setItem('ameoro-greeting-seen', '1');
    } catch (error) {
      // Blocked storage is safe to ignore: the redirect script cannot read storage either, so it never redirects.
    }
    // Nothing changed: Save simply closes. Otherwise Shopify reloads the page, which announces the choice once.
    if (s.picked === s.saved.country && s.lang === s.saved.lang) { e.preventDefault(); dialog.close(); announceSaved(); return; }
    // Blocked storage only skips the "Saved" announcement after the reload; the choice itself still posts.
    try { sessionStorage.setItem('ameoro-g2-saved', '1'); } catch (error) {}
  });
  try {
    if (sessionStorage.getItem('ameoro-g2-saved')) { sessionStorage.removeItem('ameoro-g2-saved'); announceSaved(); }
  } catch (error) {
    // Blocked storage: no announcement was queued, so there is nothing to say.
  }
  var queued = false;
  function relayout() {
    if (queued || !dialog.open || !s) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; L = wide.matches ? LAYOUTS.desktop : LAYOUTS.mobile; render(); if (fitSheet()) render(); });
  }
  window.addEventListener('resize', relayout);
})();
